import { render, staticRenderFns } from "./summaryTable.vue?vue&type=template&id=329d068d&scoped=true&"
import script from "./summaryTable.vue?vue&type=script&lang=ts&"
export * from "./summaryTable.vue?vue&type=script&lang=ts&"
import style0 from "./summaryTable.vue?vue&type=style&index=0&id=329d068d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329d068d",
  null
  
)

export default component.exports